<template>
  <v-card color="secondary darken-3" class="mb-3">
    <v-card-title>
      <div class="d-flex justify-space-between align-center" style="width: 100%">
        <span>{{ course.name }}</span>
        <div>
          <v-btn color="red" icon @click="$emit('delete-course', course)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" v-for="(value, key) in localCategories" :key="key">
          <v-select v-model="localCategories[key]" :items="[1, 2, 3, 4]" :label="capitalize(key)" dense></v-select>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn color="primary" @click="save">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CourseCategories",
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      names: {
        endurance: "Ausdauer",
        strength: "Kraft",
        mobility: "Beweglichkeit",
        resilience: "Resilienz",
        coordination: "Koordination",
      },
      // Lokale Kopie der Kategorien, damit Änderungen unabhängig erfolgen
      localCategories: { ...this.course.categories },
    }
  },
  watch: {
    // Falls sich der Kurs (oder seine Kategorien) von außen ändert, aktualisiere die lokale Kopie
    course: {
      handler(newVal) {
        this.localCategories = { ...newVal.categories }
      },
      deep: true,
    },
  },
  methods: {
    capitalize(str) {
      return this.names[str]
    },
    save() {
      // Übermittle die geänderten Kategorien an die Parent-Komponente
      this.$emit("save-categories", {
        id: this.course._id,
        categories: this.localCategories,
      })
    },
  },
}
</script>
